// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"p-","text":"p_","subText":"qa","toggleContainer":"qb","checked":"qc"};